<template>
  <div>
    <vx-card class="mt-5" title="¿En qué proyectos deseas invertir?">
      <div class="vx-row">
        <div class="vx-col xxl:w-3/4 w-full">
          <p>Elige las calificaciones de proyectos que más se acerquen a tus preferencias de inversión.
            Te recomendamos que escojas al menos 3 grupos de calificaciones con el objetivo de maximizar la diversificación y minimizar el riesgo.</p>
          <vs-alert v-if="onError" color="danger" class="mt-3" style="height: auto">{{ errorMssg }}</vs-alert>
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col lg:w-2/3 w-full">
          <div class="vx-row mt-6">
            <div class="vx-col w-1/3 text-center">
              <div class="q-box">
                <p><strong>Calificación</strong></p>
              </div>
              <div v-for="q in qualificationRates" class="q-box center mt-5" :class="'bg-' + qualificationCode(q.qualification)">
                <p class="bold pt-1 text-white">{{ q.qualification }}</p>
              </div>
            </div>
            <div class="vx-col w-1/3 text-center">
              <div class="q-box">
                <p><strong>Tasa</strong></p>
              </div>
              <div v-for="q in qualificationRates" class="q-box center mt-5" :class="'bg-' + qualificationCode(q.qualification)">
                <p class="bold pt-1 text-white">{{ rateFormat(q.bottom, q.top) }}</p>
              </div>
            </div>
            <div class="vx-col w-1/6 text-center">
              <div class="checkbox default mb-4">
                <vs-checkbox v-model="mainCheckbox" :disabled="true"></vs-checkbox>
              </div>
              <div v-for="q in qualificationRates" class="checkbox options">
                <div class="ck-box center mt-5 pt-3">
                  <vs-checkbox
                    :name="`check_${qualificationCode(q.qualification)}`"
                    :vs-value="q.qualification"
                    :disabled="true"
                    v-model.lazy="qualifications">
                  </vs-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import qualificationsHelper from "@mixins/qualificationsHelper";
export default {
  name: "ProjectsQualificationSet",
  mixins: [qualificationsHelper],
  props: {
    investorPlan: { type: Object, required: true },
    InvestorId: {
      type: [String,Number],
      required: true
    },
  },
  data() {
    return {
      qualificationRates: [],
      qualifications: [],
      mainCheckbox: true,
      onError: false,
      errorMssg: null,
      minSelect: 3,
    }
  },
  async beforeMount() {
    this.showLoading(true)
    await this.getQualificationRateParams();
    this.setDefaults();
    this.showLoading(false)
  },
  methods: {
    async getQualificationRateParams(){
      try {
        const res = await axios.get('/api/inversionista/getQualificationRateParameters');
        let allRates = res.data;
        let groupRates = [];
        let letters = [];
        allRates.forEach(f => {
          let letter = this.getGroupedQualif(f.qualification);
          if(!letters.includes(letter)){
            letters.push(letter);
          }
          groupRates.push({letter: letter, rate: f.rate});
        });

        letters.forEach(letter => {
          let g = groupRates.filter(f => f.letter === letter);
          g.sort(function(a, b) {
            if(a.rate > b.rate){
              return 1
            }
            if(a.rate < b.rate){
              return -1
            }
            return 0;
          });
          let min = g[0].rate;
          let max = g[g.length - 1].rate;
          this.qualificationRates.push({qualification: letter, bottom: min, top: max});
        });
      }
      catch (e) {
      }
    },
    getGroupedQualif(qualification){
      return qualification.replace('+', '').replace('-','');
    },
    onMainCheckboxChange(){
      if(this.mainCheckbox){
        this.setAllQualifications();
      }
      else {
        this.clearAllQualifications();
      }
    },
    setDefaults(){
      this.loadQualificationsForUser(this.investorPlan.qualifications);
      if(this.qualifications.length === 0){
        // si el usuario no ha elegido ninguna calificacion, se le asignan todas por default
        this.setAllQualifications();
      }
    },
    loadQualificationsForUser(qualificationsStr){
      this.qualifications = this.getGroupedQualifications(qualificationsStr);
    },
    setAllQualifications(){
      this.qualificationRates.forEach(f => this.qualifications.push(f.qualification));
    },
    clearAllQualifications(){
      this.qualifications = [];
    },
    getGroupedQualifications(qualificationsStr){
      let letters = [];
      if(qualificationsStr && qualificationsStr !== ""){
        let qualis = qualificationsStr.split(",");
        qualis.forEach(f => {
          let letter = this.getGroupedQualif(f);
          if(!letters.includes(letter)){
            letters.push(letter);
          }
        });
      }
      return letters;
    },
    getExpandedQualifications(qualifsArray){
      let expanded = [];
      let str1 = qualifsArray.join(",");
      let arr1 = this.getGroupedQualifications(str1);
      arr1.forEach(f => {
        expanded.push(f);
        expanded.push(f + "+");
        expanded.push(f + "-");
      });
      return expanded.join(",");
    },
    async saveSettings(){
      this.clean();
      if(this.qualifications.length < this.minSelect){
        this.onError = true;
        this.errorMssg = `Debes seleccionar al menos ${this.minSelect} opciones para poder continuar.`;
        return;
      }

      this.showLoading(true)
      let qualificationsStr = this.getExpandedQualifications(this.qualifications);
      try {
        let payload = {
          qualifications: qualificationsStr,
        };

        await axios.post(`api/v2/investor/${this.InvestorId}/setProjectQualificationsPrefs`, payload);

        this.successNotifDialog('Operación exitosa',
          'Se han actualizado exitosamente tus preferencias de calificaciones de proyectos.');

        await this.$emit('on-saved');
      }
      catch(e){
        this.errorNotifDialog('Error en guardado', 'No ha sido posible actualizar la información, intente más tarde.');
      }
      this.showLoading(false)
    },
    clean(){
      this.onError = false
      this.errorMssg = null
    },
    async cancel(){
      await this.$emit('on-cancel');
    },
    rateFormat(bottom, top){
      return `${(bottom * 100).toFixed(2)}% - ${(top * 100).toFixed(2)}%`;
    },
  }
}
</script>


<style lang="scss">
.ck-box {
  height: 30px;
}

.q-box {
  color: #000;
  border: 2px solid #000;
  height: 30px;
}

.q-box p {
  margin: 0 !important;
  padding-top: 1px;
}

.side {
  margin-top: 10px;
}

.center {
  margin-top: 10px;
}

.q-box.side p{
  margin: 2.1em 0 !important;
}

.q-box.center {
  border: none;
  color: #fff;
}

</style>
